// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1YOPl","col":"CardReaderDesc_col__6sly2","label":"CardReaderDesc_label__19BSZ"};